import { useTranslation } from 'next-i18next'
import clsx from 'clsx'

import { ICVMatchPercentageProps } from './types'

const MatchPercentage = ({
  matchPercentage,
  className
}: ICVMatchPercentageProps) => {
  const { t } = useTranslation(['crm'])
  return (
    <div className={clsx('flex-col justify-center align-middle', className)}>
      <span className="text-center">{matchPercentage}%</span>
      <span>{t('project.match', { ns: 'crm' })}</span>
    </div>
  )
}

export default MatchPercentage
